titles:
  settings: Instellingen
  subtitle: Pas je voorkeuren aan
  changePassword: Wachtwoord wijzigen
fields:
  language: Taal
  profilePicture: Profielfoto
  currentPassword: Huidig wachtwoord
  password: Nieuw wachtwoord
  passwordConfirmation: Herhaal nieuw wachtwoord
hints:
  choosePreferredLanguage: Kies je voorkeurstaal
  changeProfilePicture: Klik op het camera icoon om je profielfoto aan te passen
messages:
  changePasswordDescription: Vul hieronder een sterk wachtwoord in
actions:
  changePassword: Wijzig wachtwoord
enums:
  language:
    dutch: Nederlands
